import { digitalSuitePublisherAnalysisNavBarContent } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/ad-intelligence/publisherAnalysisNavObj";
import type { ISecondaryBarContents } from "app/components/sidebar3/secondary-side-bar/types/ISecondaryBarContents";

import { SI_PA_ROUTES } from "./constants";

export const salesPublisherAnalysisNavBarContent = (): ISecondaryBarContents =>
    digitalSuitePublisherAnalysisNavBarContent({
        homeState: SI_PA_ROUTES.home,
        routeOverrides: {
            overview: SI_PA_ROUTES.overview,
            advertisers: SI_PA_ROUTES.advertisers,
            ads: SI_PA_ROUTES.ads,
        },
    });
